import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import SimplifiedSignup from '@/components/SimplifiedSignup';
import MonthlyOfferConfig from '@/components/SimplifiedSignup/configs/MonthlyOffer/Flow';
import { SimplifiedSignupContextProvider } from '@/components/SimplifiedSignup/Context';
import { shapeConfigForParams } from '@/components/SimplifiedSignup/Context/utils';
import { InitRequest } from '@/hooks/store';
import type { InitialServerState } from '@/store';
import { resolveCheckoutSessionsEnabled } from '@/utils/experiments/resolveCheckoutSessionsEnabled';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';
import isUSPricing from '@/utils/prices/isUSPricing';

type Props = {
	initialState: InitialServerState | null;
	isCheckoutSessionsEnabled: boolean;
};

const MonthlyOfferPage = ({ isCheckoutSessionsEnabled }: Props) => {
	return (
		<Layout pageName="monthly_offer" title="Calm - Monthly Offer">
			<SimplifiedSignupContextProvider
				flowConfig={MonthlyOfferConfig}
				isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
			>
				<SimplifiedSignup />
			</SimplifiedSignupContextProvider>
		</Layout>
	);
};

export default MonthlyOfferPage;

export const getServerSideProps: GetServerSideProps<Props> = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.PRICES, InitRequest.USER],
		shapeConfigForParams(MonthlyOfferConfig),
	);

	if (
		initialState?.prices &&
		initialState?.device &&
		!isUSPricing(initialState?.prices, initialState?.device)
	) {
		return {
			redirect: {
				destination: '/signup-flow',
				permanent: false,
			},
		};
	}

	// Resolved server-side so the payment screen's first render already
	// knows the buyer's `www-checkout-sessions` bucket (see the enrollment
	// latch in PaymentElementsFormRefresh).
	const isCheckoutSessionsEnabled = await resolveCheckoutSessionsEnabled(initialState);

	return {
		props: {
			initialState,
			isCheckoutSessionsEnabled,
		},
	};
};
